import { Button, Modal, Result } from 'antd';
import { useSelector } from 'react-redux';

const ErrorModal = () => {
    const { isVisible, error } = useSelector(state => state.global.errorModalProps);

    const onReload = () => {
        window.location.reload();
    };

    return (
        <Modal centered visible={isVisible} footer={null} closable={false} maskClosable={false}>
            <Result
                status='error'
                title={error.title}
                subTitle={error.description}
                extra={[
                    <Button type='primary' onClick={onReload}>
                        Reload
                    </Button>,
                ]}
            />
        </Modal>
    );
};

export default ErrorModal;
